import * as React from "react";
import ParallaxHero from "../../common/ParallaxHero";
import CustomGallery from "../../routes/CaseStudy/v1/CaseStudyMediaGallery";
import { ParallaxText, Testimony, TwoColumn } from "../library";
import { CTA as CallToAction } from "../library";
import CaseStudyImageText from "./Blocks/CaseStudyImageText";
import { TitleText } from "./Blocks/TitleText";
import SiteMockup from "../../routes/CaseStudy/GelbertCaseStudy/SiteMockup";
import ReactPlayer from "react-player";
import { ContentfulImageQuery, Img } from "wmk-image";
import { BlockTwoColumn } from "../../../fragments/blockTwoColumnFields";
import { BlockTestimony } from "../../../fragments/blockTestimonyFields";
import { BlockParallaxText } from "../../../fragments/blockParallaxTextFields";
import { BlockCta } from "../../../fragments/blockCTAFields";
import BlockIconButtonsRow from "../library/BlockIconButtonsRow/BlockIconButtonsRow";
import { BlockIconButtonsRowFields } from "../../../fragments/blockIconButtonsRowFields";
import { IconButtonsRow } from "../../../classes/IconButtonsRow";
import { NodeGlobalOptionsInt } from "../../../fragments/nodeGlobalOptions";
import SolutionsSections from "../../routes/Solutions/SolutionsSections/SolutionsSections";
import { BlockCtaTitleTextAndButtonQuery } from "../../../fragments/blockCTATitleTextAndButtonFields";
import { CtaTitleTextButton } from "../../ui/CtaTitleTextButton";
import { BlockTitleTextAndIconsRowFields } from "../../../fragments/blockTitleTextAndIconsRowFields";
import BlockTitleTextAndIconsRow from "../library/BlockTitleTextAndIconsRow";
import { BlockLogoDisplayFields } from "../../../fragments/blockLogoDisplayFields";
import BlockLogoDisplay from "../library/BlockLogoDisplay";
import HubspotCTAComp from "../library/HubspotCTA";
import BlockIconCopy from "../library/BlockIconCopy";

export const NullComponent = () => <></>;

export const CompHash = {
  ContentfulImageGallery: ({ images }: { images: ContentfulImageQuery[] }) => {
    return (
      <CustomGallery
        img={Array.isArray(images) ? images.map((i) => new Img(i)) : []}
      />
    );
  },
  ContentfulCaseStudyBlockTextImage: ({
    displayStyle,
    image,
    mediaEffect,
    title,
    copy,
  }: {
    displayStyle: "Columns" | "Rows";
    image: ContentfulImageQuery;
    mediaEffect: "None" | "Slide In Up" | "Parallax Right";
    title: string;
    copy: { copy: string };
  }) => (
    <CaseStudyImageText
      displayStyle={displayStyle}
      image={new Img(image)}
      mediaEffect={mediaEffect}
      title={title}
      text={copy?.copy}
    />
  ),
  ContentfulBlockTwoColumn: (props: BlockTwoColumn) => (
    <TwoColumn block={{ ...props }} />
  ),
  ContentfulBlockHero: ({ image, title }: { image: ContentfulImageQuery, title: string }) => (
    <ParallaxHero image={new Img(image)} title={title}/>
  ),
  ContentfulBlockTestimonials: (props: BlockTestimony) => (
    <Testimony block={{ ...props }} />
  ),
  ContentfulBlockIconButtonsRow: (props: BlockIconButtonsRowFields) => (
    <BlockIconButtonsRow block={new IconButtonsRow({ ...props })} />
  ),
  ContentfulHubspotCta: ({
    embedCode,
  }: {
    embedCode: { embedCode: string };
  }) => <HubspotCTAComp embedCode={embedCode}/>,
  ContentfulBlockTitleText: TitleText,
  ContentfulBlockParallaxText: (props: BlockParallaxText) => (
    <ParallaxText block={{ ...props }} />
  ),
  ContentfulBlockCta: (props: BlockCta) => (
    <CallToAction block={{ ...props }} />
  ),
  ContentfulYouTubeVideo: ({ url }: { url: string }) =>
    url ? <ReactPlayer url={url} className="react-player" /> : null,
  ContentfulLinksExternal: ({
    url,
    linkText,
  }: {
    url: string;
    linkText: string;
  }) => <SiteMockup url={url} title={linkText} />,
  ContentfulGlobalOptions: (props: NodeGlobalOptionsInt) => {
    const _props = { ...props };
    const slug = _props.slug;
    const JSX = slug === "solutions-sections" ? <SolutionsSections block={_props} /> : null;
    return JSX;
  },
  ContentfulBlockCtaTitleTextAndButton: (props: BlockCtaTitleTextAndButtonQuery) => {
    return <CtaTitleTextButton block={props} />
  },
  ContentfulBlockTitleTextAndIconsRow: (props: BlockTitleTextAndIconsRowFields) => {
    return <BlockTitleTextAndIconsRow block={props} />
  },
  ContentfulBlockLogoDisplay: (props: BlockLogoDisplayFields) => {
    return <BlockLogoDisplay block={props} />
  },
  ContentfulIconCopy: (props) => {
    return <BlockIconCopy block={props} />
  }
};
